import React, { useState } from "react";
import { motion } from "framer-motion";
import bgHero from "../../assets/bghero.png";
import posterHero from "../../assets/girlwlaptop.png";
import ConsultationModal from "../Modal/ConsultationModal";

const HeroSection = () => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <section
        id="home"
        className="relative text-primary px-5 md:px-10 overflow-hidden bg-[#FFE3E3]"
      >
        <img
          src={bgHero}
          alt="background"
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover z-0"
        />
        <div className="absolute inset-0 bg-white/30 z-0"></div>
        <div className="grid grid-flow-col relative z-10">
          {/* Image Animation */}
          <motion.div
            className="hidden lg:flex justify-center"
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <img
              src={posterHero}
              alt="Virtual Assistant at work"
              className="pt-10"
            />
          </motion.div>

          {/* Text Animation */}
          <motion.div
            className="max-w-6xl my-auto text-center lg:text-left py-8 lg:py-4"
            initial={{ x: 100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <motion.h1
              className="text-3xl lg:text-4xl xl:text-5xl font-bold mb-4 tracking-wider"
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.4 }}
            >
              Stop Managing Tasks. <br />
              Start Running Your Business.
            </motion.h1>

            <motion.p
              className="text-black text-lg md:text-xl mb-10 max-w-3xl mx-auto leading-relaxed"
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.6 }}
            >
              Get a trained Virtual Assistant backed by systems, structure, and
              a support team, so you don't have to manage everything yourself.
            </motion.p>

            <motion.div
              className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start"
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.8 }}
            >
              <button
                onClick={() => setOpenModal(true)}
                className="bg-primary text-white md:text-sm px-8 py-3 rounded-lg font-semibold shadow border border-primary hover:bg-white hover:text-primary transition"
              >
                Book a Free Consultation
              </button>

              <button className="text-black outline outline-primary md:text-sm px-8 py-3 rounded-lg font-semibold hover:bg-primary hover:text-white transition">
                Get Matched with a VA
              </button>
            </motion.div>
          </motion.div>
        </div>
      </section>

      <ConsultationModal
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
      />
    </>
  );
};

export default HeroSection;
